export const efundingFaqServices = [
  {
    id: 1,
    label:
      "Pertanyaan Seputar Layanan <span style='color: #F7BD3A;'> Efunding </span>",
    child: [
      {
        id: 1,
        title: "Apa Itu Pusat Layanan Efunding?",
        description:
          "Pusat Pusat Layanan Efunding adalah kumpulan layanan keuangan syariah yang disediakan oleh Efunding. Melalui Pusat Layanan Keuangan Syariah Efunding, Anda bisa membuka tabungan syariah dan deposito syariah, serta mengajukan pembiayaan pemilikan motor baru, mobil baru dan rumah.",
      },
      {
        id: 2,
        title: "Ragam Jenis Layanan yang Tersedia di Efunding?",
        description:
          "Layanan Simpanan (Tabungan Syariah dan Deposito Syariah) Layanan Pembiayaan (Pemilikan Motor Baru, Pemilikan Mobil Baru, dan Pemilikan Rumah)",
      },
      {
        id: 3,
        title: "Apa Itu Tabungan Syariah?",
        description:
          "Tabungan Syariah adalah produk simpanan yang dikelola dengan akad-akad syariah seperti: Wadiah (titipan) – nasabah menitipkan dana, dan BPRS boleh mengelola dana tersebut tanpa kewajiban memberikan imbal hasil, tetapi BPRS bisa memberikan bonus secara sukarela. Mudharabah (bagi hasil) – nasabah memberikan dana kepada BPRS untuk dikelola secara produktif, dan hasil usaha dibagi sesuai nisbah (persentase) yang disepakati di awal.",
      },
      {
        id: 4,
        title: "Apa Itu Deposito Syariah?",
        description:
          "PT Efunding Teknologi Keuangan telah memiliki lisensi TERDAFTAR dari Otoritas Jasa Keuangan berdasarkan surat nomor S-61/IK.01/2025.",
      },
      {
        id: 5,
        title: "Apa yang Bisa Saya Dapatkan dari Efunding?",
        description:
          "Deposito syariah adalah simpanan dari nasabah yang ditahan dalam jangka waktu tertentu (misalnya 1, 3, 6, atau 12 bulan), lalu dikelola oleh BPRS untuk kegiatan usaha yang halal dan produktif. Hasil keuntungan dari pengelolaan itu akan dibagi kepada nasabah sesuai nisbah (rasio bagi hasil) yang disepakati di awal.",
      },
      {
        id: 6,
        title: "Apa Itu Pembiayaan Pemilikan Motor Baru?",
        description: ` <ul style='list-style: disc;'>
                Pembiayaan Syariah untuk Pemilikan Mobil Baru adalah fasilitas pembiayaan dari BPRS yang memungkinkan Anda memiliki mobil baru dengan cara angsuran, yang dikelola sesuai prinsip syariah Islam (bebas riba, transparan, dan penuh keberkahan).
                Pembiayaan ini menggunakan akad syariah seperti:
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Murabahah (jual beli) — Bank membeli mobil atas permintaan nasabah, lalu menjualnya kembali kepada nasabah dengan margin keuntungan yang disepakati.</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Ijarah Muntahiya Bittamlik (IMBT) — Skema sewa yang diakhiri dengan kepemilikan.</p>
                </li>
            </ul`,
      },
      {
        id: 7,
        title: "Apa Itu Pembiayaan Pemilikan Rumah?",
        description: ` <ul style='list-style: disc;'>
                Pembiayaan Syariah untuk Pemilikan Rumah adalah fasilitas pembiayaan dari BPRS yang memungkinkan Anda memiliki rumah idaman dengan cara angsuran, yang dikelola sesuai prinsip syariah Islam (bebas riba, transparan, dan penuh keberkahan).
                Pembiayaan ini menggunakan akad syariah seperti:
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Murabahah (jual beli) — Bank membeli rumah atas permintaan nasabah, lalu menjualnya kembali kepada nasabah dengan margin keuntungan yang disepakati.</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Ijarah Muntahiya Bittamlik (IMBT) — Skema sewa yang diakhiri dengan kepemilikan.</p>
                </li>
            </ul`,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_faq_services.js